import { useUserContext } from 'features/user/context';

import { BaseMessage } from '../config/types/Message';

export const useLatestMessageShouldTriggerScroll = (
  messages: BaseMessage[]
) => {
  const { user } = useUserContext();

  const latestMessage = messages[messages.length - 1];

  // only own non scheduled messages should trigger scroll to bottom
  return (
    Boolean(latestMessage) &&
    latestMessage.fromUserId === user.userId &&
    !latestMessage.scheduledMessageId
  );
};
